import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, WalletDetailed, walletDetailedSchema } from '../types';

export type OriginalWalletRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	accountId: number;
};

export type WalletRegistryFilters = Record<string, never>;

export type WalletRegistryParams = RegistryParams<WalletRegistryFilters>;

export type WalletsRegistryQuery = RegistryQuery<
	WalletDetailed,
	WalletRegistryFilters,
	JsonApiRequestError
>;

export const createWalletRegistryQuery = ($accountId: Store<number>): WalletsRegistryQuery =>
	createAuthQuery({
		params: declareParams<WalletRegistryParams>(),
		request: {
			method: 'GET',
			url: '/account/wallet/list',
			query: {
				source: $accountId,
				fn: (params, id): OriginalWalletRegistryParams => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					accountId: id,
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(walletDetailedSchema)),
		},
	});
